import { render, staticRenderFns } from "./EditSituacao.vue?vue&type=template&id=4948bebe"
import script from "./EditSituacao.vue?vue&type=script&lang=js"
export * from "./EditSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports